import React from "react"

import { Modal, theme } from "@singita/components"

const FullModal = ({ title, children, isOpen, toggleModal }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      title={title}
      handleClose={toggleModal}
      bg={theme.colors.brandBeige}
    >
      {children}
    </Modal>
  )
}

export default FullModal
